module.exports=[
     {
    "src": "assets/img/library/hillary.jpg",
    "title": "Clinton campaign agrees to back Jill Stein 's election recount effort: Lawyer",
    "type": "Partner Story",
    "source": "New York Times",
    "status": "Published",
    "updated": "12/04/2016",
    "updatedTimestamp": 1480809600,
    "updatedAuthor": "Janie Young",
    "created": "12/04/2016",
    "createdTimestamp": 1480809600,
    "createdAuthor": "Stephanie Horton",
    "sections": ["Politics"],
    "tags": ["Hillary Clinton", "Jill Stein"]
  },
  {
    "src": "assets/img/media/104212150-RTX2YHOW.530x298.jpg",
    "title": "Russia poses a danger; US must be clear-eyed about relationship: Tillerson",
    "type": "News Story",
    "status": "Published",
    "updated": "01/11/2017",
    "updatedTimestamp": 1484092800,
    "updatedAuthor": "Lester Stephens",
    "created": "01/11/2017",
    "createdTimestamp": 1484092800,
    "createdAuthor": "Stephanie Horton",
    "sections": ["Politics"],
    "tags": ["Rex Tillerson", "Exxon Mobil", "Russia"]
  },
  {
    "src": "assets/img/media/104208217-GettyImages-631334970.530x298.jpg",
    "title": "What Trump doesn't know about Alibaba's jobs pledge",
    "type": "Breaking News",
    "status": "Not Published",
    "updated": "01/11/2017",
    "updatedTimestamp": 1484092800,
    "updatedAuthor": "Jeff Daniels",
    "created": "01/10/2017",
    "createdTimestamp": 1484006400,
    "createdAuthor": "Jeff Daniels",
    "sections": ["Technology"],
    "tags": ["Donald Trump", "Jack Ma", "Alibaba Group"]
  },
  {
    "src": "assets/img/media/103662363-David_Plouffe_046r.530x298.jpg",
    "title": "Uber's David Plouffe to join Chan Zuckerberg Initiative",
    "type": "News Story",
    "status": "Published",
    "updated": "01/10/2017",
    "updatedTimestamp": 1484006400,
    "updatedAuthor": "Kerry Hunter",
    "created": "01/10/2017",
    "createdTimestamp": 1484006400,
    "createdAuthor": "Kerry Hunter",
    "sections": ["Social Media"],
    "tags": ["Uber", "David Plouffe", "Chan Zuckerberg", "Facebook"]
  },
  {
    "src": "assets/img/media/101036349-172296312.530x298.jpg",
    "title": "Credit card, auto loan delinquencies rise",
    "type": "News Story",
    "status": "Published",
    "updated": "01/10/2017",
    "updatedTimestamp": 1484006400,
    "updatedAuthor": "Janie Young",
    "created": "01/09/2017",
    "createdTimestamp": 1483920000,
    "createdAuthor": "Stephanie Horton",
    "sections": ["Personal Finance"],
    "tags": ["credit card", "auto loan", "debt"]
  },
  {
    "src": "assets/img/media/104004769-GettyImages-613366722.530x298.jpg",
    "title": "US had its second-hottest year, along with weather and climate disasters that cost $46 billion",
    "type": "Wire Story",
    "source": "Financial Times",
    "status": "Published",
    "updated": "01/09/2017",
    "updatedTimestamp": 1483920000,
    "updatedAuthor": "Kerry Hunter",
    "created": "01/07/2017",
    "createdTimestamp": 1483747200,
    "createdAuthor": "Lester Stephens",
    "sections": ["Weather"],
    "tags": ["Climate", "Global Warming"]
  },
  {
    "src": "assets/img/media/103849102-AP-467499764.530x298.jpg",
    "title": "Food companies are cooking up new recipes for your favorite foods",
    "type": "News Story",
    "status": "Draft",
    "updated": "12/08/2016",
    "updatedTimestamp": 1481155200,
    "updatedAuthor": "Jeff Daniels",
    "created": "12/07/2016",
    "createdTimestamp": 1481068800,
    "createdAuthor": "Jeff Daniels",
    "sections": ["Food and Beverage"],
    "tags": ["McDonald's", "Panera Bread", "Heinz"]
  },
  {
    "src": "assets/img/media/103863243-GettyImages-588424834.530x298.jpg",
    "title": "Macy's earnings: 17 cents per share, vs expected EPS of 41 cents",
    "type": "News Story",
    "status": "Published",
    "updated": "12/04/2016",
    "updatedTimestamp": 1481155200,
    "updatedAuthor": "Kerry Hunter",
    "created": "12/04/2016",
    "createdTimestamp": 1481155200,
    "createdAuthor": "Kerry Hunter",
    "sections": ["Earnings"],
    "tags": ["Macy's"]
  },
  {
    "src": "assets/img/library/google-coach.jpg",
    "title": "Ex-Google career coach shares 4-step strategy for dealing with a job you hate",
    "type": "News Story",
    "status": "Draft",
    "updated": "12/02/2016",
    "updatedTimestamp": 1481155200,
    "updatedAuthor": "Kerry Hunter",
    "created": "12/02/2016",
    "createdTimestamp": 1481155200,
    "createdAuthor": "Lester Stephens",
    "sections": ["Make It"],
    "tags": ["Google", "Jenny Blake"]
  },
  {
    "src": "assets/img/library/diy-self.jpg",
    "title": "Do-it-yourself retirement for the self-employed",
    "type": "Partner Story",
    "status": "Published",
    "updated": "12/02/2016",
    "updatedTimestamp": 1481155200,
    "updatedAuthor": "Kerry Hunter",
    "created": "12/02/2016",
    "createdTimestamp": 1481155200,
    "createdAuthor": "Kerry Hunter",
    "sections": ["Investment Strategies"],
    "tags": ["IRA"]
  },
  {
    "src": "assets/img/library/macbook-pro.jpg",
    "title": "Apple unveils new MacBook Pro with Touch Bar, starting at $1,799",
    "type": "News Story",
    "status": "Not Published",
    "updated": "12/02/2016",
    "updatedTimestamp": 1481155200,
    "updatedAuthor": "Ricky Rodriquez",
    "created": "12/02/2016",
    "createdTimestamp": 1481155200,
    "createdAuthor": "Janie Young",
    "sections": ["Technology"],
    "tags": ["Apple", "MacBook Pro"]
  },
  {
    "src": "assets/img/library/tesla.jpg",
    "title": "Tesla shares downshift into uncertainty after Republican sweep",
    "type": "Breaking News",
    "status": "Published",
    "updated": "11/30/2016",
    "updatedTimestamp": 1480464000,
    "updatedAuthor": "Bill Owen",
    "created": "11/30/2016",
    "createdTimestamp": 1480464000,
    "createdAuthor": "Stephanie Horton",
    "sections": ["Market Insider"],
    "tags": ["Tesla", "Elon Musk", "SolarCity"]
  },
  {
    "src": "assets/img/library/jack-dorsey.jpg",
    "title": "Jack Dorsey: 2 books that influenced me most have nothing to do with business",
    "type": "News Story",
    "status": "Published",
    "updated": "11/29/2016",
    "updatedTimestamp": 1480377600,
    "updatedAuthor": "Bill Owen",
    "created": "11/29/2016",
    "createdTimestamp": 1480377600,
    "createdAuthor": "Janie Young",
    "sections": ["Make It-Entrepreneurs"],
    "tags": ["Jack Dorsey", "Twitter", "Square"]
  },
  {
    "src": "assets/img/library/austin-movie.jpg",
    "title": "Move over, Hollywood. Atlanta is becoming a major film mecca",
    "type": "News Story",
    "status": "Draft",
    "updated": "11/28/2016",
    "updatedTimestamp": 1480291200,
    "updatedAuthor": "Lucia Wang",
    "created": "11/27/2016",
    "createdTimestamp": 1480204800,
    "createdAuthor": "Lester Stephens",
    "sections": ["Make It"],
    "tags": ["Atlanta GA", "Georgia Film Academy"]
  },
  {
    "src": "assets/img/library/gamers.jpg",
    "title": "Must-have video games this holiday season",
    "type": "Gallery",
    "status": "Published",
    "updated": "10/27/2016",
    "updatedTimestamp": 1477526400,
    "updatedAuthor": "Bill Owen",
    "created": "10/20/2016",
    "createdTimestamp": 1476921600,
    "createdAuthor": "Stephanie Horton",
    "sections": ["Holiday Central"],
    "tags": ["Sony", "Civilization VI"]
  },
  {
    "src": "assets/img/media/104208217-GettyImages-631334970.530x298.jpg",
    "title": "What Trump doesn't know about Alibaba's jobs pledge",
    "type": "Breaking News",
    "status": "Not Published",
    "updated": "01/11/2017",
    "updatedTimestamp": 1484092800,
    "updatedAuthor": "Jeff Daniels",
    "created": "01/10/2017",
    "createdTimestamp": 1484006400,
    "createdAuthor": "Jeff Daniels",
    "sections": ["Technology"],
    "tags": ["Donald Trump", "Jack Ma", "Alibaba Group"]
  },
  {
    "src": "assets/img/media/103662363-David_Plouffe_046r.530x298.jpg",
    "title": "Uber's David Plouffe to join Chan Zuckerberg Initiative",
    "type": "News Story",
    "status": "Published",
    "updated": "01/10/2017",
    "updatedTimestamp": 1484006400,
    "updatedAuthor": "Kerry Hunter",
    "created": "01/10/2017",
    "createdTimestamp": 1484006400,
    "createdAuthor": "Kerry Hunter",
    "sections": ["Social Media"],
    "tags": ["Uber", "David Plouffe", "Chan Zuckerberg", "Facebook"]
  },
  {
    "src": "assets/img/media/101036349-172296312.530x298.jpg",
    "title": "Credit card, auto loan delinquencies rise",
    "type": "News Story",
    "status": "Published",
    "updated": "01/10/2017",
    "updatedTimestamp": 1484006400,
    "updatedAuthor": "Janie Young",
    "created": "01/09/2017",
    "createdTimestamp": 1483920000,
    "createdAuthor": "Stephanie Horton",
    "sections": ["Personal Finance"],
    "tags": ["credit card", "auto loan", "debt"]
  },
  {
    "src": "assets/img/media/104004769-GettyImages-613366722.530x298.jpg",
    "title": "US had its second-hottest year, along with weather and climate disasters that cost $46 billion",
    "type": "Wire Story",
    "status": "Published",
    "updated": "01/09/2017",
    "updatedTimestamp": 1483920000,
    "updatedAuthor": "Kerry Hunter",
    "created": "01/07/2017",
    "createdTimestamp": 1483747200,
    "createdAuthor": "Lester Stephens",
    "sections": ["Weather"],
    "tags": ["Climate", "Global Warming"]
  },
  {
    "src": "assets/img/media/103849102-AP-467499764.530x298.jpg",
    "title": "Food companies are cooking up new recipes for your favorite foods",
    "type": "News Story",
    "status": "Draft",
    "updated": "12/08/2016",
    "updatedTimestamp": 1481155200,
    "updatedAuthor": "Jeff Daniels",
    "created": "12/07/2016",
    "createdTimestamp": 1481068800,
    "createdAuthor": "Jeff Daniels",
    "sections": ["Food and Beverage"],
    "tags": ["McDonald's", "Panera Bread", "Heinz"]
  },
  {
    "src": "assets/img/media/103863243-GettyImages-588424834.530x298.jpg",
    "title": "Macy's earnings: 17 cents per share, vs expected EPS of 41 cents",
    "type": "News Story",
    "status": "Published",
    "updated": "12/04/2016",
    "updatedTimestamp": 1481155200,
    "updatedAuthor": "Kerry Hunter",
    "created": "12/04/2016",
    "createdTimestamp": 1481155200,
    "createdAuthor": "Kerry Hunter",
    "sections": ["Earnings"],
    "tags": ["Macy's"]
  },
  {
    "src": "assets/img/library/hillary.jpg",
    "title": "Clinton campaign agrees to back Jill Stein 's election recount effort: Lawyer",
    "type": "Partner Story",
    "status": "Published",
    "updated": "12/04/2016",
    "updatedTimestamp": 1480809600,
    "updatedAuthor": "Janie Young",
    "created": "12/04/2016",
    "createdTimestamp": 1480809600,
    "createdAuthor": "Stephanie Horton",
    "sections": ["Politics"],
    "tags": ["Hillary Clinton", "Jill Stein"]
  },
  {
    "src": "assets/img/library/google-coach.jpg",
    "title": "Ex-Google career coach shares 4-step strategy for dealing with a job you hate",
    "type": "News Story",
    "status": "Draft",
    "updated": "12/02/2016",
    "updatedTimestamp": 1481155200,
    "updatedAuthor": "Kerry Hunter",
    "created": "12/02/2016",
    "createdTimestamp": 1481155200,
    "createdAuthor": "Lester Stephens",
    "sections": ["Make It"],
    "tags": ["Google", "Jenny Blake"]
  },
  {
    "src": "assets/img/library/diy-self.jpg",
    "title": "Do-it-yourself retirement for the self-employed",
    "type": "Partner Story",
    "status": "Published",
    "updated": "12/02/2016",
    "updatedTimestamp": 1481155200,
    "updatedAuthor": "Kerry Hunter",
    "created": "12/02/2016",
    "createdTimestamp": 1481155200,
    "createdAuthor": "Kerry Hunter",
    "sections": ["Investment Strategies"],
    "tags": ["IRA"]
  },
  {
    "src": "assets/img/library/macbook-pro.jpg",
    "title": "Apple unveils new MacBook Pro with Touch Bar, starting at $1,799",
    "type": "News Story",
    "status": "Not Published",
    "updated": "12/02/2016",
    "updatedTimestamp": 1481155200,
    "updatedAuthor": "Ricky Rodriquez",
    "created": "12/02/2016",
    "createdTimestamp": 1481155200,
    "createdAuthor": "Janie Young",
    "sections": ["Technology"],
    "tags": ["Apple", "MacBook Pro"]
  },
  {
    "src": "assets/img/library/tesla.jpg",
    "title": "Tesla shares downshift into uncertainty after Republican sweep",
    "type": "Breaking News",
    "status": "Published",
    "updated": "11/30/2016",
    "updatedTimestamp": 1480464000,
    "updatedAuthor": "Bill Owen",
    "created": "11/30/2016",
    "createdTimestamp": 1480464000,
    "createdAuthor": "Stephanie Horton",
    "sections": ["Market Insider"],
    "tags": ["Tesla", "Elon Musk", "SolarCity"]
  },
  {
    "src": "assets/img/library/jack-dorsey.jpg",
    "title": "Jack Dorsey: 2 books that influenced me most have nothing to do with business",
    "type": "News Story",
    "status": "Published",
    "updated": "11/29/2016",
    "updatedTimestamp": 1480377600,
    "updatedAuthor": "Bill Owen",
    "created": "11/29/2016",
    "createdTimestamp": 1480377600,
    "createdAuthor": "Janie Young",
    "sections": ["Make It-Entrepreneurs"],
    "tags": ["Jack Dorsey", "Twitter", "Square"]
  },
  {
    "src": "assets/img/library/austin-movie.jpg",
    "title": "Move over, Hollywood. Atlanta is becoming a major film mecca",
    "type": "News Story",
    "status": "Draft",
    "updated": "11/28/2016",
    "updatedTimestamp": 1480291200,
    "updatedAuthor": "Lucia Wang",
    "created": "11/27/2016",
    "createdTimestamp": 1480204800,
    "createdAuthor": "Lester Stephens",
    "sections": ["Make It"],
    "tags": ["Atlanta GA", "Georgia Film Academy"]
  },
  {
    "src": "assets/img/library/gamers.jpg",
    "title": "Must-have video games this holiday season",
    "type": "Gallery",
    "status": "Published",
    "updated": "10/27/2016",
    "updatedTimestamp": 1477526400,
    "updatedAuthor": "Bill Owen",
    "created": "10/20/2016",
    "createdTimestamp": 1476921600,
    "createdAuthor": "Stephanie Horton",
    "sections": ["Holiday Central"],
    "tags": ["Sony", "Civilization VI"]
  },
  {
    "src": "assets/img/media/104212150-RTX2YHOW.530x298.jpg",
    "title": "Russia poses a danger; US must be clear-eyed about relationship: Tillerson",
    "type": "News Story",
    "status": "Published",
    "updated": "01/11/2017",
    "updatedTimestamp": 1484092800,
    "updatedAuthor": "Lester Stephens",
    "created": "01/11/2017",
    "createdTimestamp": 1484092800,
    "createdAuthor": "Stephanie Horton",
    "sections": ["Politics"],
    "tags": ["Rex Tillerson", "Exxon Mobil", "Russia"]
  },
  {
    "src": "assets/img/media/104208217-GettyImages-631334970.530x298.jpg",
    "title": "What Trump doesn't know about Alibaba's jobs pledge",
    "type": "Breaking News",
    "status": "Not Published",
    "updated": "01/11/2017",
    "updatedTimestamp": 1484092800,
    "updatedAuthor": "Jeff Daniels",
    "created": "01/10/2017",
    "createdTimestamp": 1484006400,
    "createdAuthor": "Jeff Daniels",
    "sections": ["Technology"],
    "tags": ["Donald Trump", "Jack Ma", "Alibaba Group"]
  },
  {
    "src": "assets/img/media/103662363-David_Plouffe_046r.530x298.jpg",
    "title": "Uber's David Plouffe to join Chan Zuckerberg Initiative",
    "type": "News Story",
    "status": "Published",
    "updated": "01/10/2017",
    "updatedTimestamp": 1484006400,
    "updatedAuthor": "Kerry Hunter",
    "created": "01/10/2017",
    "createdTimestamp": 1484006400,
    "createdAuthor": "Kerry Hunter",
    "sections": ["Social Media"],
    "tags": ["Uber", "David Plouffe", "Chan Zuckerberg", "Facebook"]
  },
  {
    "src": "assets/img/media/101036349-172296312.530x298.jpg",
    "title": "Credit card, auto loan delinquencies rise",
    "type": "News Story",
    "status": "Published",
    "updated": "01/10/2017",
    "updatedTimestamp": 1484006400,
    "updatedAuthor": "Janie Young",
    "created": "01/09/2017",
    "createdTimestamp": 1483920000,
    "createdAuthor": "Stephanie Horton",
    "sections": ["Personal Finance"],
    "tags": ["credit card", "auto loan", "debt"]
  },
  {
    "src": "assets/img/media/104004769-GettyImages-613366722.530x298.jpg",
    "title": "US had its second-hottest year, along with weather and climate disasters that cost $46 billion",
    "type": "Wire Story",
    "status": "Published",
    "updated": "01/09/2017",
    "updatedTimestamp": 1483920000,
    "updatedAuthor": "Kerry Hunter",
    "created": "01/07/2017",
    "createdTimestamp": 1483747200,
    "createdAuthor": "Lester Stephens",
    "sections": ["Weather"],
    "tags": ["Climate", "Global Warming"]
  },
  {
    "src": "assets/img/media/103849102-AP-467499764.530x298.jpg",
    "title": "Food companies are cooking up new recipes for your favorite foods",
    "type": "News Story",
    "status": "Draft",
    "updated": "12/08/2016",
    "updatedTimestamp": 1481155200,
    "updatedAuthor": "Jeff Daniels",
    "created": "12/07/2016",
    "createdTimestamp": 1481068800,
    "createdAuthor": "Jeff Daniels",
    "sections": ["Food and Beverage"],
    "tags": ["McDonald's", "Panera Bread", "Heinz"]
  },
  {
    "src": "assets/img/library/hillary.jpg",
    "title": "Clinton campaign agrees to back Jill Stein 's election recount effort: Lawyer",
    "type": "Partner Story",
    "status": "Published",
    "updated": "12/04/2016",
    "updatedTimestamp": 1480809600,
    "updatedAuthor": "Janie Young",
    "created": "12/04/2016",
    "createdTimestamp": 1480809600,
    "createdAuthor": "Stephanie Horton",
    "sections": ["Politics"],
    "tags": ["Hillary Clinton", "Jill Stein"]
  },
  {
    "src": "assets/img/library/google-coach.jpg",
    "title": "Ex-Google career coach shares 4-step strategy for dealing with a job you hate",
    "type": "News Story",
    "status": "Draft",
    "updated": "12/02/2016",
    "updatedTimestamp": 1481155200,
    "updatedAuthor": "Kerry Hunter",
    "created": "12/02/2016",
    "createdTimestamp": 1481155200,
    "createdAuthor": "Lester Stephens",
    "sections": ["Make It"],
    "tags": ["Google", "Jenny Blake"]
  },
  {
    "src": "assets/img/library/diy-self.jpg",
    "title": "Do-it-yourself retirement for the self-employed",
    "type": "Partner Story",
    "status": "Published",
    "updated": "12/02/2016",
    "updatedTimestamp": 1481155200,
    "updatedAuthor": "Kerry Hunter",
    "created": "12/02/2016",
    "createdTimestamp": 1481155200,
    "createdAuthor": "Kerry Hunter",
    "sections": ["Investment Strategies"],
    "tags": ["IRA"]
  },
  {
    "src": "assets/img/library/macbook-pro.jpg",
    "title": "Apple unveils new MacBook Pro with Touch Bar, starting at $1,799",
    "type": "News Story",
    "status": "Not Published",
    "updated": "12/02/2016",
    "updatedTimestamp": 1481155200,
    "updatedAuthor": "Ricky Rodriquez",
    "created": "12/02/2016",
    "createdTimestamp": 1481155200,
    "createdAuthor": "Janie Young",
    "sections": ["Technology"],
    "tags": ["Apple", "MacBook Pro"]
  },
  {
    "src": "assets/img/library/tesla.jpg",
    "title": "Tesla shares downshift into uncertainty after Republican sweep",
    "type": "Breaking News",
    "status": "Published",
    "updated": "11/30/2016",
    "updatedTimestamp": 1480464000,
    "updatedAuthor": "Bill Owen",
    "created": "11/30/2016",
    "createdTimestamp": 1480464000,
    "createdAuthor": "Stephanie Horton",
    "sections": ["Market Insider"],
    "tags": ["Tesla", "Elon Musk", "SolarCity"]
  },
  {
    "src": "assets/img/library/jack-dorsey.jpg",
    "title": "Jack Dorsey: 2 books that influenced me most have nothing to do with business",
    "type": "News Story",
    "status": "Published",
    "updated": "11/29/2016",
    "updatedTimestamp": 1480377600,
    "updatedAuthor": "Bill Owen",
    "created": "11/29/2016",
    "createdTimestamp": 1480377600,
    "createdAuthor": "Janie Young",
    "sections": ["Make It-Entrepreneurs"],
    "tags": ["Jack Dorsey", "Twitter", "Square"]
  },
  {
    "src": "assets/img/library/austin-movie.jpg",
    "title": "Move over, Hollywood. Atlanta is becoming a major film mecca",
    "type": "News Story",
    "status": "Draft",
    "updated": "11/28/2016",
    "updatedTimestamp": 1480291200,
    "updatedAuthor": "Lucia Wang",
    "created": "11/27/2016",
    "createdTimestamp": 1480204800,
    "createdAuthor": "Lester Stephens",
    "sections": ["Make It"],
    "tags": ["Atlanta GA", "Georgia Film Academy"]
  },
  {
    "src": "assets/img/library/gamers.jpg",
    "title": "Must-have video games this holiday season",
    "type": "Gallery",
    "status": "Published",
    "updated": "10/27/2016",
    "updatedTimestamp": 1477526400,
    "updatedAuthor": "Bill Owen",
    "created": "10/20/2016",
    "createdTimestamp": 1476921600,
    "createdAuthor": "Stephanie Horton",
    "sections": ["Holiday Central"],
    "tags": ["Sony", "Civilization VI"]
  },
  {
    "src": "assets/img/media/104212150-RTX2YHOW.530x298.jpg",
    "title": "Russia poses a danger; US must be clear-eyed about relationship: Tillerson",
    "type": "News Story",
    "status": "Published",
    "updated": "01/11/2017",
    "updatedTimestamp": 1484092800,
    "updatedAuthor": "Lester Stephens",
    "created": "01/11/2017",
    "createdTimestamp": 1484092800,
    "createdAuthor": "Stephanie Horton",
    "sections": ["Politics"],
    "tags": ["Rex Tillerson", "Exxon Mobil", "Russia"]
  },
  {
    "src": "assets/img/media/104208217-GettyImages-631334970.530x298.jpg",
    "title": "What Trump doesn't know about Alibaba's jobs pledge",
    "type": "Breaking News",
    "status": "Not Published",
    "updated": "01/11/2017",
    "updatedTimestamp": 1484092800,
    "updatedAuthor": "Jeff Daniels",
    "created": "01/10/2017",
    "createdTimestamp": 1484006400,
    "createdAuthor": "Jeff Daniels",
    "sections": ["Technology"],
    "tags": ["Donald Trump", "Jack Ma", "Alibaba Group"]
  },
  {
    "src": "assets/img/media/103662363-David_Plouffe_046r.530x298.jpg",
    "title": "Uber's David Plouffe to join Chan Zuckerberg Initiative",
    "type": "News Story",
    "status": "Published",
    "updated": "01/10/2017",
    "updatedTimestamp": 1484006400,
    "updatedAuthor": "Kerry Hunter",
    "created": "01/10/2017",
    "createdTimestamp": 1484006400,
    "createdAuthor": "Kerry Hunter",
    "sections": ["Social Media"],
    "tags": ["Uber", "David Plouffe", "Chan Zuckerberg", "Facebook"]
  },
  {
    "src": "assets/img/media/101036349-172296312.530x298.jpg",
    "title": "Credit card, auto loan delinquencies rise",
    "type": "News Story",
    "status": "Published",
    "updated": "01/10/2017",
    "updatedTimestamp": 1484006400,
    "updatedAuthor": "Janie Young",
    "created": "01/09/2017",
    "createdTimestamp": 1483920000,
    "createdAuthor": "Stephanie Horton",
    "sections": ["Personal Finance"],
    "tags": ["credit card", "auto loan", "debt"]
  },
  {
    "src": "assets/img/media/104004769-GettyImages-613366722.530x298.jpg",
    "title": "US had its second-hottest year, along with weather and climate disasters that cost $46 billion",
    "type": "Wire Story",
    "source": "New York Times",
    "status": "Published",
    "updated": "01/09/2017",
    "updatedTimestamp": 1483920000,
    "updatedAuthor": "Kerry Hunter",
    "created": "01/07/2017",
    "createdTimestamp": 1483747200,
    "createdAuthor": "Lester Stephens",
    "sections": ["Weather"],
    "tags": ["Climate", "Global Warming"]
  },
  {
    "src": "assets/img/media/103849102-AP-467499764.530x298.jpg",
    "title": "Food companies are cooking up new recipes for your favorite foods",
    "type": "News Story",
    "status": "Draft",
    "updated": "12/08/2016",
    "updatedTimestamp": 1481155200,
    "updatedAuthor": "Jeff Daniels",
    "created": "12/07/2016",
    "createdTimestamp": 1481068800,
    "createdAuthor": "Jeff Daniels",
    "sections": ["Food and Beverage"],
    "tags": ["McDonald's", "Panera Bread", "Heinz"]
  },
  {
    "src": "assets/img/media/103863243-GettyImages-588424834.530x298.jpg",
    "title": "Macy's earnings: 17 cents per share, vs expected EPS of 41 cents",
    "type": "News Story",
    "status": "Published",
    "updated": "12/04/2016",
    "updatedTimestamp": 1481155200,
    "updatedAuthor": "Kerry Hunter",
    "created": "12/04/2016",
    "createdTimestamp": 1481155200,
    "createdAuthor": "Kerry Hunter",
    "sections": ["Earnings"],
    "tags": ["Macy's"]
  },
  {
    "src": "assets/img/library/hillary.jpg",
    "title": "Clinton campaign agrees to back Jill Stein 's election recount effort: Lawyer",
    "type": "Partner Story",
    "status": "Published",
    "updated": "12/04/2016",
    "updatedTimestamp": 1480809600,
    "updatedAuthor": "Janie Young",
    "created": "12/04/2016",
    "createdTimestamp": 1480809600,
    "createdAuthor": "Stephanie Horton",
    "sections": ["Politics"],
    "tags": ["Hillary Clinton", "Jill Stein"]
  },
  {
    "src": "assets/img/library/google-coach.jpg",
    "title": "Ex-Google career coach shares 4-step strategy for dealing with a job you hate",
    "type": "News Story",
    "status": "Draft",
    "updated": "12/02/2016",
    "updatedTimestamp": 1481155200,
    "updatedAuthor": "Kerry Hunter",
    "created": "12/02/2016",
    "createdTimestamp": 1481155200,
    "createdAuthor": "Lester Stephens",
    "sections": ["Make It"],
    "tags": ["Google", "Jenny Blake"]
  },
  {
    "src": "assets/img/library/diy-self.jpg",
    "title": "Do-it-yourself retirement for the self-employed",
    "type": "Partner Story",
    "status": "Published",
    "updated": "12/02/2016",
    "updatedTimestamp": 1481155200,
    "updatedAuthor": "Kerry Hunter",
    "created": "12/02/2016",
    "createdTimestamp": 1481155200,
    "createdAuthor": "Kerry Hunter",
    "sections": ["Investment Strategies"],
    "tags": ["IRA"]
  },
  {
    "src": "assets/img/library/macbook-pro.jpg",
    "title": "Apple unveils new MacBook Pro with Touch Bar, starting at $1,799",
    "type": "News Story",
    "status": "Not Published",
    "updated": "12/02/2016",
    "updatedTimestamp": 1481155200,
    "updatedAuthor": "Ricky Rodriquez",
    "created": "12/02/2016",
    "createdTimestamp": 1481155200,
    "createdAuthor": "Janie Young",
    "sections": ["Technology"],
    "tags": ["Apple", "MacBook Pro"]
  },
  {
    "src": "assets/img/library/tesla.jpg",
    "title": "Tesla shares downshift into uncertainty after Republican sweep",
    "type": "Breaking News",
    "status": "Published",
    "updated": "11/30/2016",
    "updatedTimestamp": 1480464000,
    "updatedAuthor": "Bill Owen",
    "created": "11/30/2016",
    "createdTimestamp": 1480464000,
    "createdAuthor": "Stephanie Horton",
    "sections": ["Market Insider"],
    "tags": ["Tesla", "Elon Musk", "SolarCity"]
  },
  {
    "src": "assets/img/library/jack-dorsey.jpg",
    "title": "Jack Dorsey: 2 books that influenced me most have nothing to do with business",
    "type": "News Story",
    "status": "Published",
    "updated": "11/29/2016",
    "updatedTimestamp": 1480377600,
    "updatedAuthor": "Bill Owen",
    "created": "11/29/2016",
    "createdTimestamp": 1480377600,
    "createdAuthor": "Janie Young",
    "sections": ["Make It-Entrepreneurs"],
    "tags": ["Jack Dorsey", "Twitter", "Square"]
  },
  {
    "src": "assets/img/library/austin-movie.jpg",
    "title": "Move over, Hollywood. Atlanta is becoming a major film mecca",
    "type": "News Story",
    "status": "Draft",
    "updated": "11/28/2016",
    "updatedTimestamp": 1480291200,
    "updatedAuthor": "Lucia Wang",
    "created": "11/27/2016",
    "createdTimestamp": 1480204800,
    "createdAuthor": "Lester Stephens",
    "sections": ["Make It"],
    "tags": ["Atlanta GA", "Georgia Film Academy"]
  },
  {
    "src": "assets/img/library/gamers.jpg",
    "title": "Must-have video games this holiday season",
    "type": "Gallery",
    "status": "Published",
    "updated": "10/27/2016",
    "updatedTimestamp": 1477526400,
    "updatedAuthor": "Bill Owen",
    "created": "10/20/2016",
    "createdTimestamp": 1476921600,
    "createdAuthor": "Stephanie Horton",
    "sections": ["Holiday Central"],
    "tags": ["Sony", "Civilization VI"]
  },
  {
    "src": "assets/img/media/104212150-RTX2YHOW.530x298.jpg",
    "title": "Russia poses a danger; US must be clear-eyed about relationship: Tillerson",
    "type": "News Story",
    "source": "New York Times",
    "status": "Published",
    "updated": "01/11/2017",
    "updatedTimestamp": 1484092800,
    "updatedAuthor": "Lester Stephens",
    "created": "01/11/2017",
    "createdTimestamp": 1484092800,
    "createdAuthor": "Stephanie Horton",
    "sections": ["Politics"],
    "tags": ["Rex Tillerson", "Exxon Mobil", "Russia"]
  },
  {
    "src": "assets/img/media/104208217-GettyImages-631334970.530x298.jpg",
    "title": "What Trump doesn't know about Alibaba's jobs pledge",
    "type": "Breaking News",
    "status": "Not Published",
    "updated": "01/11/2017",
    "updatedTimestamp": 1484092800,
    "updatedAuthor": "Jeff Daniels",
    "created": "01/10/2017",
    "createdTimestamp": 1484006400,
    "createdAuthor": "Jeff Daniels",
    "sections": ["Technology"],
    "tags": ["Donald Trump", "Jack Ma", "Alibaba Group"]
  },
  {
    "src": "assets/img/media/103662363-David_Plouffe_046r.530x298.jpg",
    "title": "Uber's David Plouffe to join Chan Zuckerberg Initiative",
    "type": "News Story",
    "status": "Published",
    "updated": "01/10/2017",
    "updatedTimestamp": 1484006400,
    "updatedAuthor": "Kerry Hunter",
    "created": "01/10/2017",
    "createdTimestamp": 1484006400,
    "createdAuthor": "Kerry Hunter",
    "sections": ["Social Media"],
    "tags": ["Uber", "David Plouffe", "Chan Zuckerberg", "Facebook"]
  },
  {
    "src": "assets/img/media/101036349-172296312.530x298.jpg",
    "title": "Credit card, auto loan delinquencies rise",
    "type": "News Story",
    "status": "Published",
    "updated": "01/10/2017",
    "updatedTimestamp": 1484006400,
    "updatedAuthor": "Janie Young",
    "created": "01/09/2017",
    "createdTimestamp": 1483920000,
    "createdAuthor": "Stephanie Horton",
    "sections": ["Personal Finance"],
    "tags": ["credit card", "auto loan", "debt"]
  },
  {
    "src": "assets/img/media/104004769-GettyImages-613366722.530x298.jpg",
    "title": "US had its second-hottest year, along with weather and climate disasters that cost $46 billion",
    "type": "Wire Story",
    "status": "Published",
    "updated": "01/09/2017",
    "updatedTimestamp": 1483920000,
    "updatedAuthor": "Kerry Hunter",
    "created": "01/07/2017",
    "createdTimestamp": 1483747200,
    "createdAuthor": "Lester Stephens",
    "sections": ["Weather"],
    "tags": ["Climate", "Global Warming"]
  },
  {
    "src": "assets/img/media/103849102-AP-467499764.530x298.jpg",
    "title": "Food companies are cooking up new recipes for your favorite foods",
    "type": "News Story",
    "status": "Draft",
    "updated": "12/08/2016",
    "updatedTimestamp": 1481155200,
    "updatedAuthor": "Jeff Daniels",
    "created": "12/07/2016",
    "createdTimestamp": 1481068800,
    "createdAuthor": "Jeff Daniels",
    "sections": ["Food and Beverage"],
    "tags": ["McDonald's", "Panera Bread", "Heinz"]
  },
  {
    "src": "assets/img/media/103863243-GettyImages-588424834.530x298.jpg",
    "title": "Macy's earnings: 17 cents per share, vs expected EPS of 41 cents",
    "type": "News Story",
    "status": "Published",
    "updated": "12/04/2016",
    "updatedTimestamp": 1481155200,
    "updatedAuthor": "Kerry Hunter",
    "created": "12/04/2016",
    "createdTimestamp": 1481155200,
    "createdAuthor": "Kerry Hunter",
    "sections": ["Earnings"],
    "tags": ["Macy's"]
  },
  {
    "src": "assets/img/library/hillary.jpg",
    "title": "Clinton campaign agrees to back Jill Stein 's election recount effort: Lawyer",
    "type": "Partner Story",
    "status": "Published",
    "updated": "12/04/2016",
    "updatedTimestamp": 1480809600,
    "updatedAuthor": "Janie Young",
    "created": "12/04/2016",
    "createdTimestamp": 1480809600,
    "createdAuthor": "Stephanie Horton",
    "sections": ["Politics"],
    "tags": ["Hillary Clinton", "Jill Stein"]
  },
  {
    "src": "assets/img/library/google-coach.jpg",
    "title": "Ex-Google career coach shares 4-step strategy for dealing with a job you hate",
    "type": "News Story",
    "status": "Draft",
    "updated": "12/02/2016",
    "updatedTimestamp": 1481155200,
    "updatedAuthor": "Kerry Hunter",
    "created": "12/02/2016",
    "createdTimestamp": 1481155200,
    "createdAuthor": "Lester Stephens",
    "sections": ["Make It"],
    "tags": ["Google", "Jenny Blake"]
  },
  {
    "src": "assets/img/library/diy-self.jpg",
    "title": "Do-it-yourself retirement for the self-employed",
    "type": "Partner Story",
    "status": "Published",
    "updated": "12/02/2016",
    "updatedTimestamp": 1481155200,
    "updatedAuthor": "Kerry Hunter",
    "created": "12/02/2016",
    "createdTimestamp": 1481155200,
    "createdAuthor": "Kerry Hunter",
    "sections": ["Investment Strategies"],
    "tags": ["IRA"]
  },
  {
    "src": "assets/img/library/macbook-pro.jpg",
    "title": "Apple unveils new MacBook Pro with Touch Bar, starting at $1,799",
    "type": "News Story",
    "status": "Not Published",
    "updated": "12/02/2016",
    "updatedTimestamp": 1481155200,
    "updatedAuthor": "Ricky Rodriquez",
    "created": "12/02/2016",
    "createdTimestamp": 1481155200,
    "createdAuthor": "Janie Young",
    "sections": ["Technology"],
    "tags": ["Apple", "MacBook Pro"]
  },
  {
    "src": "assets/img/library/tesla.jpg",
    "title": "Tesla shares downshift into uncertainty after Republican sweep",
    "type": "Breaking News",
    "status": "Published",
    "updated": "11/30/2016",
    "updatedTimestamp": 1480464000,
    "updatedAuthor": "Bill Owen",
    "created": "11/30/2016",
    "createdTimestamp": 1480464000,
    "createdAuthor": "Stephanie Horton",
    "sections": ["Market Insider"],
    "tags": ["Tesla", "Elon Musk", "SolarCity"]
  },
  {
    "src": "assets/img/library/jack-dorsey.jpg",
    "title": "Jack Dorsey: 2 books that influenced me most have nothing to do with business",
    "type": "News Story",
    "status": "Published",
    "updated": "11/29/2016",
    "updatedTimestamp": 1480377600,
    "updatedAuthor": "Bill Owen",
    "created": "11/29/2016",
    "createdTimestamp": 1480377600,
    "createdAuthor": "Janie Young",
    "sections": ["Make It-Entrepreneurs"],
    "tags": ["Jack Dorsey", "Twitter", "Square"]
  },
  {
    "src": "assets/img/library/austin-movie.jpg",
    "title": "Move over, Hollywood. Atlanta is becoming a major film mecca",
    "type": "News Story",
    "status": "Draft",
    "updated": "11/28/2016",
    "updatedTimestamp": 1480291200,
    "updatedAuthor": "Lucia Wang",
    "created": "11/27/2016",
    "createdTimestamp": 1480204800,
    "createdAuthor": "Lester Stephens",
    "sections": ["Make It"],
    "tags": ["Atlanta GA", "Georgia Film Academy"]
  },
  {
    "src": "assets/img/library/gamers.jpg",
    "title": "Must-have video games this holiday season",
    "type": "Gallery",
    "status": "Published",
    "updated": "10/27/2016",
    "updatedTimestamp": 1477526400,
    "updatedAuthor": "Bill Owen",
    "created": "10/20/2016",
    "createdTimestamp": 1476921600,
    "createdAuthor": "Stephanie Horton",
    "sections": ["Holiday Central"],
    "tags": ["Sony", "Civilization VI"]
  },
  {
    "src": "assets/img/media/104212150-RTX2YHOW.530x298.jpg",
    "title": "Russia poses a danger; US must be clear-eyed about relationship: Tillerson",
    "type": "News Story",
    "status": "Published",
    "updated": "01/11/2017",
    "updatedTimestamp": 1484092800,
    "updatedAuthor": "Lester Stephens",
    "created": "01/11/2017",
    "createdTimestamp": 1484092800,
    "createdAuthor": "Stephanie Horton",
    "sections": ["Politics"],
    "tags": ["Rex Tillerson", "Exxon Mobil", "Russia"]
  },
  {
    "src": "assets/img/media/104208217-GettyImages-631334970.530x298.jpg",
    "title": "What Trump doesn't know about Alibaba's jobs pledge",
    "type": "Breaking News",
    "status": "Not Published",
    "updated": "01/11/2017",
    "updatedTimestamp": 1484092800,
    "updatedAuthor": "Jeff Daniels",
    "created": "01/10/2017",
    "createdTimestamp": 1484006400,
    "createdAuthor": "Jeff Daniels",
    "sections": ["Technology"],
    "tags": ["Donald Trump", "Jack Ma", "Alibaba Group"]
  },
  {
    "src": "assets/img/media/103662363-David_Plouffe_046r.530x298.jpg",
    "title": "Uber's David Plouffe to join Chan Zuckerberg Initiative",
    "type": "News Story",
    "status": "Published",
    "updated": "01/10/2017",
    "updatedTimestamp": 1484006400,
    "updatedAuthor": "Kerry Hunter",
    "created": "01/10/2017",
    "createdTimestamp": 1484006400,
    "createdAuthor": "Kerry Hunter",
    "sections": ["Social Media"],
    "tags": ["Uber", "David Plouffe", "Chan Zuckerberg", "Facebook"]
  },
  {
    "src": "assets/img/media/101036349-172296312.530x298.jpg",
    "title": "Credit card, auto loan delinquencies rise",
    "type": "News Story",
    "status": "Published",
    "updated": "01/10/2017",
    "updatedTimestamp": 1484006400,
    "updatedAuthor": "Janie Young",
    "created": "01/09/2017",
    "createdTimestamp": 1483920000,
    "createdAuthor": "Stephanie Horton",
    "sections": ["Personal Finance"],
    "tags": ["credit card", "auto loan", "debt"]
  },
  {
    "src": "assets/img/media/104004769-GettyImages-613366722.530x298.jpg",
    "title": "US had its second-hottest year, along with weather and climate disasters that cost $46 billion",
    "type": "Wire Story",
    "status": "Published",
    "updated": "01/09/2017",
    "updatedTimestamp": 1483920000,
    "updatedAuthor": "Kerry Hunter",
    "created": "01/07/2017",
    "createdTimestamp": 1483747200,
    "createdAuthor": "Lester Stephens",
    "sections": ["Weather"],
    "tags": ["Climate", "Global Warming"]
  },
  {
    "src": "assets/img/media/103849102-AP-467499764.530x298.jpg",
    "title": "Food companies are cooking up new recipes for your favorite foods",
    "type": "News Story",
    "status": "Draft",
    "updated": "12/08/2016",
    "updatedTimestamp": 1481155200,
    "updatedAuthor": "Jeff Daniels",
    "created": "12/07/2016",
    "createdTimestamp": 1481068800,
    "createdAuthor": "Jeff Daniels",
    "sections": ["Food and Beverage"],
    "tags": ["McDonald's", "Panera Bread", "Heinz"]
  },
  {
    "src": "assets/img/media/103863243-GettyImages-588424834.530x298.jpg",
    "title": "Macy's earnings: 17 cents per share, vs expected EPS of 41 cents",
    "type": "News Story",
    "status": "Published",
    "updated": "12/04/2016",
    "updatedTimestamp": 1481155200,
    "updatedAuthor": "Kerry Hunter",
    "created": "12/04/2016",
    "createdTimestamp": 1481155200,
    "createdAuthor": "Kerry Hunter",
    "sections": ["Earnings"],
    "tags": ["Macy's"]
  },
  {
    "src": "assets/img/library/google-coach.jpg",
    "title": "Ex-Google career coach shares 4-step strategy for dealing with a job you hate",
    "type": "News Story",
    "status": "Draft",
    "updated": "12/02/2016",
    "updatedTimestamp": 1481155200,
    "updatedAuthor": "Kerry Hunter",
    "created": "12/02/2016",
    "createdTimestamp": 1481155200,
    "createdAuthor": "Lester Stephens",
    "sections": ["Make It"],
    "tags": ["Google", "Jenny Blake"]
  },
  {
    "src": "assets/img/library/diy-self.jpg",
    "title": "Do-it-yourself retirement for the self-employed",
    "type": "Partner Story",
    "status": "Published",
    "updated": "12/02/2016",
    "updatedTimestamp": 1481155200,
    "updatedAuthor": "Kerry Hunter",
    "created": "12/02/2016",
    "createdTimestamp": 1481155200,
    "createdAuthor": "Kerry Hunter",
    "sections": ["Investment Strategies"],
    "tags": ["IRA"]
  },
  {
    "src": "assets/img/library/macbook-pro.jpg",
    "title": "Apple unveils new MacBook Pro with Touch Bar, starting at $1,799",
    "type": "News Story",
    "status": "Not Published",
    "updated": "12/02/2016",
    "updatedTimestamp": 1481155200,
    "updatedAuthor": "Ricky Rodriquez",
    "created": "12/02/2016",
    "createdTimestamp": 1481155200,
    "createdAuthor": "Janie Young",
    "sections": ["Technology"],
    "tags": ["Apple", "MacBook Pro"]
  },
  {
    "src": "assets/img/library/tesla.jpg",
    "title": "Tesla shares downshift into uncertainty after Republican sweep",
    "type": "Breaking News",
    "status": "Published",
    "updated": "11/30/2016",
    "updatedTimestamp": 1480464000,
    "updatedAuthor": "Bill Owen",
    "created": "11/30/2016",
    "createdTimestamp": 1480464000,
    "createdAuthor": "Stephanie Horton",
    "sections": ["Market Insider"],
    "tags": ["Tesla", "Elon Musk", "SolarCity"]
  },
  {
    "src": "assets/img/library/jack-dorsey.jpg",
    "title": "Jack Dorsey: 2 books that influenced me most have nothing to do with business",
    "type": "News Story",
    "status": "Published",
    "updated": "11/29/2016",
    "updatedTimestamp": 1480377600,
    "updatedAuthor": "Bill Owen",
    "created": "11/29/2016",
    "createdTimestamp": 1480377600,
    "createdAuthor": "Janie Young",
    "sections": ["Make It-Entrepreneurs"],
    "tags": ["Jack Dorsey", "Twitter", "Square"]
  },
  {
    "src": "assets/img/library/austin-movie.jpg",
    "title": "Move over, Hollywood. Atlanta is becoming a major film mecca",
    "type": "News Story",
    "status": "Draft",
    "updated": "11/28/2016",
    "updatedTimestamp": 1480291200,
    "updatedAuthor": "Lucia Wang",
    "created": "11/27/2016",
    "createdTimestamp": 1480204800,
    "createdAuthor": "Lester Stephens",
    "sections": ["Make It"],
    "tags": ["Atlanta GA", "Georgia Film Academy"]
  },
  {
    "src": "assets/img/library/gamers.jpg",
    "title": "Must-have video games this holiday season",
    "type": "Gallery",
    "status": "Published",
    "updated": "10/27/2016",
    "updatedTimestamp": 1477526400,
    "updatedAuthor": "Bill Owen",
    "created": "10/20/2016",
    "createdTimestamp": 1476921600,
    "createdAuthor": "Stephanie Horton",
    "sections": ["Holiday Central"],
    "tags": ["Sony", "Civilization VI"]
  },
  {
    "src": "assets/img/media/104212150-RTX2YHOW.530x298.jpg",
    "title": "Russia poses a danger; US must be clear-eyed about relationship: Tillerson",
    "type": "News Story",
    "status": "Published",
    "updated": "01/11/2017",
    "updatedTimestamp": 1484092800,
    "updatedAuthor": "Lester Stephens",
    "created": "01/11/2017",
    "createdTimestamp": 1484092800,
    "createdAuthor": "Stephanie Horton",
    "sections": ["Politics"],
    "tags": ["Rex Tillerson", "Exxon Mobil", "Russia"]
  },
  {
    "src": "assets/img/media/104208217-GettyImages-631334970.530x298.jpg",
    "title": "What Trump doesn't know about Alibaba's jobs pledge",
    "type": "Breaking News",
    "status": "Not Published",
    "updated": "01/11/2017",
    "updatedTimestamp": 1484092800,
    "updatedAuthor": "Jeff Daniels",
    "created": "01/10/2017",
    "createdTimestamp": 1484006400,
    "createdAuthor": "Jeff Daniels",
    "sections": ["Technology"],
    "tags": ["Donald Trump", "Jack Ma", "Alibaba Group"]
  },
  {
    "src": "assets/img/media/103662363-David_Plouffe_046r.530x298.jpg",
    "title": "Uber's David Plouffe to join Chan Zuckerberg Initiative",
    "type": "News Story",
    "status": "Published",
    "updated": "01/10/2017",
    "updatedTimestamp": 1484006400,
    "updatedAuthor": "Kerry Hunter",
    "created": "01/10/2017",
    "createdTimestamp": 1484006400,
    "createdAuthor": "Kerry Hunter",
    "sections": ["Social Media"],
    "tags": ["Uber", "David Plouffe", "Chan Zuckerberg", "Facebook"]
  },
  {
    "src": "assets/img/media/101036349-172296312.530x298.jpg",
    "title": "Credit card, auto loan delinquencies rise",
    "type": "News Story",
    "status": "Published",
    "updated": "01/10/2017",
    "updatedTimestamp": 1484006400,
    "updatedAuthor": "Janie Young",
    "created": "01/09/2017",
    "createdTimestamp": 1483920000,
    "createdAuthor": "Stephanie Horton",
    "sections": ["Personal Finance"],
    "tags": ["credit card", "auto loan", "debt"]
  },
  {
    "src": "assets/img/media/104004769-GettyImages-613366722.530x298.jpg",
    "title": "US had its second-hottest year, along with weather and climate disasters that cost $46 billion",
    "type": "Wire Story",
    "status": "Published",
    "updated": "01/09/2017",
    "updatedTimestamp": 1483920000,
    "updatedAuthor": "Kerry Hunter",
    "created": "01/07/2017",
    "createdTimestamp": 1483747200,
    "createdAuthor": "Lester Stephens",
    "sections": ["Weather"],
    "tags": ["Climate", "Global Warming"]
  },
  {
    "src": "assets/img/media/103849102-AP-467499764.530x298.jpg",
    "title": "Food companies are cooking up new recipes for your favorite foods",
    "type": "News Story",
    "status": "Draft",
    "updated": "12/08/2016",
    "updatedTimestamp": 1481155200,
    "updatedAuthor": "Jeff Daniels",
    "created": "12/07/2016",
    "createdTimestamp": 1481068800,
    "createdAuthor": "Jeff Daniels",
    "sections": ["Food and Beverage"],
    "tags": ["McDonald's", "Panera Bread", "Heinz"]
  },
  {
    "src": "assets/img/media/103863243-GettyImages-588424834.530x298.jpg",
    "title": "Macy's earnings: 17 cents per share, vs expected EPS of 41 cents",
    "type": "News Story",
    "status": "Published",
    "updated": "12/04/2016",
    "updatedTimestamp": 1481155200,
    "updatedAuthor": "Kerry Hunter",
    "created": "12/04/2016",
    "createdTimestamp": 1481155200,
    "createdAuthor": "Kerry Hunter",
    "sections": ["Earnings"],
    "tags": ["Macy's"]
  },
  {
    "src": "assets/img/library/hillary.jpg",
    "title": "Clinton campaign agrees to back Jill Stein 's election recount effort: Lawyer",
    "type": "Partner Story",
    "status": "Published",
    "updated": "12/04/2016",
    "updatedTimestamp": 1480809600,
    "updatedAuthor": "Janie Young",
    "created": "12/04/2016",
    "createdTimestamp": 1480809600,
    "createdAuthor": "Stephanie Horton",
    "sections": ["Politics"],
    "tags": ["Hillary Clinton", "Jill Stein"]
  },
  {
    "src": "assets/img/library/google-coach.jpg",
    "title": "Ex-Google career coach shares 4-step strategy for dealing with a job you hate",
    "type": "News Story",
    "status": "Draft",
    "updated": "12/02/2016",
    "updatedTimestamp": 1481155200,
    "updatedAuthor": "Kerry Hunter",
    "created": "12/02/2016",
    "createdTimestamp": 1481155200,
    "createdAuthor": "Lester Stephens",
    "sections": ["Make It"],
    "tags": ["Google", "Jenny Blake"]
  },
  {
    "src": "assets/img/library/diy-self.jpg",
    "title": "Do-it-yourself retirement for the self-employed",
    "type": "Partner Story",
    "status": "Published",
    "updated": "12/02/2016",
    "updatedTimestamp": 1481155200,
    "updatedAuthor": "Kerry Hunter",
    "created": "12/02/2016",
    "createdTimestamp": 1481155200,
    "createdAuthor": "Kerry Hunter",
    "sections": ["Investment Strategies"],
    "tags": ["IRA"]
  },
  {
    "src": "assets/img/library/macbook-pro.jpg",
    "title": "Apple unveils new MacBook Pro with Touch Bar, starting at $1,799",
    "type": "News Story",
    "status": "Not Published",
    "updated": "12/02/2016",
    "updatedTimestamp": 1481155200,
    "updatedAuthor": "Ricky Rodriquez",
    "created": "12/02/2016",
    "createdTimestamp": 1481155200,
    "createdAuthor": "Janie Young",
    "sections": ["Technology"],
    "tags": ["Apple", "MacBook Pro"]
  },
  {
    "src": "assets/img/library/tesla.jpg",
    "title": "Tesla shares downshift into uncertainty after Republican sweep",
    "type": "Breaking News",
    "status": "Published",
    "updated": "11/30/2016",
    "updatedTimestamp": 1480464000,
    "updatedAuthor": "Bill Owen",
    "created": "11/30/2016",
    "createdTimestamp": 1480464000,
    "createdAuthor": "Stephanie Horton",
    "sections": ["Market Insider"],
    "tags": ["Tesla", "Elon Musk", "SolarCity"]
  },
  {
    "src": "assets/img/library/jack-dorsey.jpg",
    "title": "Jack Dorsey: 2 books that influenced me most have nothing to do with business",
    "type": "News Story",
    "status": "Published",
    "updated": "11/29/2016",
    "updatedTimestamp": 1480377600,
    "updatedAuthor": "Bill Owen",
    "created": "11/29/2016",
    "createdTimestamp": 1480377600,
    "createdAuthor": "Janie Young",
    "sections": ["Make It-Entrepreneurs"],
    "tags": ["Jack Dorsey", "Twitter", "Square"]
  },
  {
    "src": "assets/img/library/austin-movie.jpg",
    "title": "Move over, Hollywood. Atlanta is becoming a major film mecca",
    "type": "News Story",
    "status": "Draft",
    "updated": "11/28/2016",
    "updatedTimestamp": 1480291200,
    "updatedAuthor": "Lucia Wang",
    "created": "11/27/2016",
    "createdTimestamp": 1480204800,
    "createdAuthor": "Lester Stephens",
    "sections": ["Make It"],
    "tags": ["Atlanta GA", "Georgia Film Academy"]
  },
  {
    "src": "assets/img/library/gamers.jpg",
    "title": "Must-have video games this holiday season",
    "type": "Gallery",
    "status": "Published",
    "updated": "10/27/2016",
    "updatedTimestamp": 1477526400,
    "updatedAuthor": "Bill Owen",
    "created": "10/20/2016",
    "createdTimestamp": 1476921600,
    "createdAuthor": "Stephanie Horton",
    "sections": ["Holiday Central"],
    "tags": ["Sony", "Civilization VI"]
  }
]
